var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "navbar navbar-expand-lg" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "navbar-brand" }, [
        _vm._v(_vm._s(_vm.routeName))
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "navbar-toggler navbar-toggler-right",
          class: { toggled: _vm.$sidebar.showSidebar },
          attrs: {
            type: "button",
            "aria-controls": "navigation-index",
            "aria-expanded": "false",
            "aria-label": "Toggle navigation"
          },
          on: { click: _vm.toggleSidebar }
        },
        [
          _c("span", { staticClass: "navbar-toggler-bar burger-lines" }),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-toggler-bar burger-lines" }),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-toggler-bar burger-lines" })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "collapse navbar-collapse justify-content-end" },
        [
          _c(
            "ul",
            { staticClass: "navbar-nav ml-auto" },
            [
              _c(
                "drop-down",
                {
                  staticClass: "custom-drop-down",
                  attrs: {
                    title:
                      _vm.getUserName.firstName + " " + _vm.getUserName.lastName
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      attrs: { href: "javascript:;" }
                    },
                    [
                      _c("i", { staticClass: "nc-icon nc-settings-gear-64" }),
                      _vm._v(" Setting\n            ")
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "divider m-0" }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item text-danger",
                      staticStyle: { cursor: "pointer" },
                      on: { click: _vm.logout }
                    },
                    [
                      _c("i", { staticClass: "nc-icon nc-button-power" }),
                      _vm._v(" logout\n            ")
                    ]
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-715dd82a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-715dd82a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/TopNavbar.vue
// module id = W6ey
// module chunks = 0